import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import trustLogo from './assets/trust_logo.png';

// ✅ Favicon for all devices
const setAllFavicons = () => {
  document.title = 'Help Them Shine Trust';
  const head = document.head;
  document.querySelectorAll("link[rel*='icon'], link[rel='apple-touch-icon']").forEach(el => el.remove());
  const icon = document.createElement('link');
  icon.rel = 'icon'; icon.type = 'image/png'; icon.href = trustLogo;
  head.appendChild(icon);
  const shortcut = document.createElement('link');
  shortcut.rel = 'shortcut icon'; shortcut.type = 'image/png'; shortcut.href = trustLogo;
  head.appendChild(shortcut);
  [57,72,76,114,120,144,152,180].forEach(size => {
    const apple = document.createElement('link');
    apple.rel = 'apple-touch-icon'; apple.sizes = `${size}x${size}`; apple.href = trustLogo;
    head.appendChild(apple);
  });
  const setMeta = (name, content) => {
    let el = document.querySelector(`meta[name='${name}']`) || document.createElement('meta');
    el.name = name; el.content = content; head.appendChild(el);
  };
  setMeta('msapplication-TileImage', trustLogo);
  setMeta('msapplication-TileColor', '#f59e0b');
  setMeta('theme-color', '#0a0908');
};

setAllFavicons();

window.addEventListener("error", (event) => {
  if (event.message === "Script error." && !event.filename) {
    event.stopImmediatePropagation();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
